/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Less_Quiet_Worm_AdoreInputs */

const fr_less_quiet_worm_adore = /** @type {(inputs: Less_Quiet_Worm_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un PB`)
};

/**

* @param {Less_Quiet_Worm_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const less_quiet_worm_adore = /** @type {((inputs?: Less_Quiet_Worm_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Less_Quiet_Worm_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_less_quiet_worm_adore(inputs)
});